import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueChatScroll from 'vue-chat-scroll'
import { EmojiPickerPlugin } from 'vue-emoji-picker'

Vue.use(EmojiPickerPlugin)

Vue.use(VueChatScroll)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
